export function setToken(token: string | null) {
  if (typeof window === 'undefined') return;
  try {
    if (token) {
      localStorage.setItem('token', token);
      // Cookie for SSR guard on /dashboard
      // Only mark Secure when we’re actually on HTTPS (localhost is http).
      const isHttps = window.location?.protocol === 'https:';
      const maxAge = 60 * 60 * 24 * 7; // 7 days
      document.cookie =
        `token=${encodeURIComponent(token)}; ` +
        `Path=/; SameSite=Lax; Max-Age=${maxAge}` +
        (isHttps ? '; Secure' : '');
    } else {
      localStorage.removeItem('token');
      document.cookie = 'token=; Path=/; Max-Age=0';
    }
  } catch {}
}
